import React from 'react';

import { Modal, ModalPosition } from 'ui/components/styled';
import { useFlash } from 'hooks';

export const FlashModal = (props) => {
  const { flash, clearFlash } = useFlash();
  const {
    refreshOnClose = false,
    adjustPosition = true,
    closeOnOutsideClick = true,
  } = flash?.options || {};

  const handleClose = () => {
    clearFlash();
    if (refreshOnClose) {
      window.location.reload();
    }
  };

  return (
    <Modal
      show={flash?.message}
      title={flash?.title}
      onClose={handleClose}
      position={ModalPosition.TOP_CENTER}
      adjustPosition={adjustPosition}
      closeOnOutsideClick={closeOnOutsideClick}
      top="33%"
      width="40%"
      maxWidth="650px"
      contentProps={{ userSelect: 'none' }}
      {...props}
    >
      {flash?.message}
    </Modal>
  );
};
